// Contexto de Sidebar para la aplicación Amarsi Control Panel
// Maneja el estado global de colapso de la sidebar

import React, { createContext, useContext, useState, useEffect } from 'react';

// Creación del contexto
const SidebarContext = createContext();

// Hook personalizado para usar el contexto de sidebar
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar debe ser usado dentro de un SidebarProvider');
  }
  return context;
};

// Provider del contexto de sidebar
export const SidebarProvider = ({ children }) => {
  // Estado local para la sidebar
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Recupera el estado guardado en localStorage
    const savedState = localStorage.getItem('sidebarCollapsed');
    return savedState === 'true';
  });

  // Efecto para guardar el estado en localStorage
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
  }, [isCollapsed]);

  // Función para toggle del estado de la sidebar
  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Función para setear el estado manualmente
  const setSidebarCollapsed = (collapsed) => {
    setIsCollapsed(collapsed);
  };

  // Objeto de valor del contexto
  const value = {
    isCollapsed,
    toggleSidebar,
    setSidebarCollapsed
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
